module.exports = __webpack_public_path__ + "img/bg-image-0.8ff9b73f.png";